"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripStoryCategory = void 0;
exports.TripStoryCategory = {
    PAYMENT: 'PAYMENT',
    CHECKOUT_INCIDENT: 'CHECKOUT_INCIDENT',
    DRIVER_CALL: 'DRIVER_CALL',
    TRIP_LOCK: 'TRIP_LOCK',
    STATE_UPDATE: 'STATE_UPDATE',
    TRANSPORT_UPDATE: 'TRANSPORT_UPDATE',
    PHONE_GATEWAY: 'PHONE_GATEWAY',
    LATE_CALCULATION: 'LATE_CALCULATION',
    PRICE_UPDATE: 'PRICE_UPDATE',
    OUTSOURCING: 'OUTSOURCING',
    OP_MESSAGE: 'OP_MESSAGE',
    DRIVER_CHANGE: 'DRIVER_CHANGE',
    DRIVER_CHANGE_CHECK: 'DRIVER_CHANGE_CHECK',
    TRIP_ISSUE: 'TRIP_ISSUE',
    TRIP_UPDATE: 'TRIP_UPDATE',
    CALL: 'CALL',
    MARKETPLACE: 'MARKETPLACE',
    COMMUNICATION: 'COMMUNICATION',
    TRIP_INCIDENT: 'TRIP_INCIDENT',
    LEGACY_SPYMASTER_ALERT: 'LEGACY_SPYMASTER_ALERT',
    INVOICING: 'INVOICING',
};
